export default __webpack_public_path__ + "static/media/List-documentation.62f1453d.md";